var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.048 17.5294H8.47088C4.89892 17.5294 2 20.4305 2 24C2 27.5734 4.89776 30.4706 8.47088 30.4706H23.0479C22.0044 28.5469 21.4117 26.3428 21.4117 24C21.4118 21.6574 22.0044 19.4532 23.048 17.5294ZM24 24C24 30.076 28.9245 35 35 35C41.0759 35 46 30.0755 46 24C46 17.9241 41.0755 13 35 13C28.924 13.0001 24 17.9245 24 24ZM31.844 23.5433L33.7059 25.4052L38.8068 20.3043C39.057 20.054 39.4682 20.0564 39.7232 20.3115L40.6297 21.218C40.8887 21.4769 40.8878 21.8835 40.6365 22.1348L34.621 28.1504C34.1156 28.6557 33.2962 28.6557 32.7908 28.1504L30.0122 25.3717C29.7579 25.1175 29.7623 24.7083 30.0174 24.4532L30.9238 23.5467C31.1828 23.2878 31.5908 23.2901 31.844 23.5433Z",
    fill: "#79C24F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.048 17.5294H8.47088C4.89892 17.5294 2 20.4305 2 24C2 27.5734 4.89776 30.4706 8.47088 30.4706H23.0479C22.0044 28.5469 21.4117 26.3428 21.4117 24C21.4118 21.6574 22.0044 19.4532 23.048 17.5294ZM24 24C24 30.076 28.9245 35 35 35C41.0759 35 46 30.0755 46 24C46 17.9241 41.0755 13 35 13C28.924 13.0001 24 17.9245 24 24ZM31.844 23.5433L33.7059 25.4052L38.8068 20.3043C39.057 20.054 39.4682 20.0564 39.7232 20.3115L40.6297 21.218C40.8887 21.4769 40.8878 21.8835 40.6365 22.1348L34.621 28.1504C34.1156 28.6557 33.2962 28.6557 32.7908 28.1504L30.0122 25.3717C29.7579 25.1175 29.7623 24.7083 30.0174 24.4532L30.9238 23.5467C31.1828 23.2878 31.5908 23.2901 31.844 23.5433Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/on.4b711ed0bfad5698dd6f08ecf820d869.svg";
export { ForwardRef as ReactComponent };